import React, { useEffect, useState, useCallback, useRef } from "react";
import { componenteImgSrc } from "@/lib/cloudinary";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import api, { ESTADO_PETICION, ESTADOS_PETICION_SELECCIONABLES, TIPO_LINEA, ESTADO_LINEA, ESTADO_COMPONENTE, ORIGEN_LABELS } from "@/lib/api";
import { DiagnosticoRutabilidadButton } from "@/components/DiagnosticoRutabilidad";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { RequisitosChips } from "@/components/espacios/RequisitosForm";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { ArrowLeft, Trash2, Send, Wrench, Boxes, Euro, Clock, MessageSquare, ChevronRight, Copy, Pencil, AlertCircle, Printer, Tag, Receipt, ShieldCheck, ShieldAlert, CheckCircle2, History, Bot, User as UserIcon, Truck, Package, PackageCheck, Split, Eye } from "lucide-react";
import AdjuntosBlock from "@/components/AdjuntosBlock";
import GastosBlock from "@/components/GastosBlock";
import ExtrasFacturacionBlock from "@/components/ExtrasFacturacionBlock";
import SolicitarValidacionDialog from "@/components/SolicitarValidacionDialog";
import EnvioRecogidoDialog from "@/components/EnvioRecogidoDialog";
import FinalizarSinMontajeDialog from "@/components/FinalizarSinMontajeDialog";
import { TiposLineaBadges } from "@/components/TiposLineaMulti";
import { PropuestaMontajeBanner } from "@/components/PropuestaMontajeBanner";
import { useEntityRefresh } from "@/lib/useEntityRefresh";
import { FeedbackBanner } from "@/components/FeedbackBanner";
import { FacturaFDBanner } from "@/components/FacturaFDBanner";
import { ParteMontajeBanner } from "@/components/ParteMontajeBanner";
import ComponenteDetailModal from "@/components/ComponenteDetailModal";
import { ProyectoThumb } from "@/components/ProyectoThumb";
import { RutaEditPinDialog } from "@/components/RutaEditPin";
import ReporteMontajeModal from "@/components/ReporteMontajeModal";
import MemoriaTecnicaDialog from "@/components/MemoriaTecnicaDialog";
import MemoriaMontajeDialog from "@/components/MemoriaMontajeDialog";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import ActualizarDesdeCorreoDialog from "@/components/ActualizarDesdeCorreoDialog";
import { PermisoCorreoBlock, GraficaChip } from "@/components/PermisoCorreo";
import { OrigenCorreoBlock } from "@/components/OrigenCorreoBlock";
import { useAuth } from "@/context/AuthContext";
import FiltrosBar, { uniqOptions } from "@/components/FiltrosBar";
import EnRutaBadge from "@/components/EnRutaBadge";
import ContratacionClienteBlock, { EstadoContratacionBadge } from "@/components/ContratacionClienteBlock";
import { broadcastEntityChange } from "@/lib/useEntityRefresh";
import { TRANSICIONES, ETIQUETA_ESTADOS, abrirEtiqueta, lineaIncluyeProduccion } from "@/lib/peticionWorkflow";
import { ChipSelect } from "@/components/peticion/ChipSelect";
import { HeaderImagen } from "@/components/peticion/HeaderImagen";
import { EditPeticionDialog } from "@/components/peticion/EditPeticionDialog";
import { ClonarLineaDialog } from "@/components/peticion/ClonarLineaDialog";
import { NuevaLineaDialog } from "@/components/peticion/NuevaLineaDialog";
import { NuevoComponenteDialog } from "@/components/peticion/NuevoComponenteDialog";
import { ElementosMontajeInline } from "@/components/peticion/ElementosMontajeInline";
import { PortalStatusWidget } from "@/components/peticion/PortalStatusWidget";
import { OrigenPresupuestoParcial } from "@/components/PartidasAprobacion";
export { lineaIncluyeProduccion } from "@/lib/peticionWorkflow";

export default function PeticionDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { user: currentUser, hasRole } = useAuth();
  const [data, setData] = useState(null);
  const [clientes, setClientes] = useState([]);
  // Iter 114 — Marcar MONTADO con PIN de supervisor
  const [montadoTarget, setMontadoTarget] = useState(null);
  // Jun-2026 — Ver reporte de montaje (fotos/incidencia) por línea
  const [reportesMontaje, setReportesMontaje] = useState({});
  const [reporteModal, setReporteModal] = useState(null);
  // Jun-2026 — Memoria técnica IA (Fase 1)
  const [showMemoria, setShowMemoria] = useState(false);
  const [showMemoriaMontaje, setShowMemoriaMontaje] = useState(false);
  const [memoriasMenuOpen, setMemoriasMenuOpen] = useState(false);
  const [showActualizarCorreo, setShowActualizarCorreo] = useState(false);
  const [correoInbound, setCorreoInbound] = useState(null);  // correo entrante (Resend) a revisar en esta petición
  useEffect(() => {
    const iid = new URLSearchParams(window.location.search).get("inbound");
    if (!iid) return;
    api.get(`/inbound/${iid}`).then((r) => { setCorreoInbound(r.data); setShowActualizarCorreo(true); }).catch(() => {});
  }, [id]);
  const [espacios, setEspacios] = useState([]);
  // Sep-2026 — Scroll a la línea indicada por hash (#linea-<id>) desde el buscador de líneas
  const hashScrolled = useRef(false);
  useEffect(() => {
    const h = window.location.hash;
    if (!data || hashScrolled.current || !h.startsWith("#linea-")) return;
    setTimeout(() => {
      const el = document.getElementById(h.slice(1));
      if (!el || hashScrolled.current) return;
      hashScrolled.current = true;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("ring-2", "ring-cyan-400/70");
      setTimeout(() => el.classList.remove("ring-2", "ring-cyan-400/70"), 3000);
    }, 500);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps
  const [materiales, setMateriales] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [users, setUsers] = useState([]);
  // Iter 73 — Finalizar petición a mano (cancelación / cierre)
  const [openFinalizar, setOpenFinalizar] = useState(false);
  const [cargosEstim, setCargosEstim] = useState(null);
  const [finMotivo, setFinMotivo] = useState("");
  const [finMotivoCorto, setFinMotivoCorto] = useState("cliente_canc");
  const [finCargos, setFinCargos] = useState("");
  const [finNotas, setFinNotas] = useState("");
  const [finalizando, setFinalizando] = useState(false);
  // Iter 73 — Duplicar componente preguntando línea destino (bug Fernando)
  const [dupComp, setDupComp] = useState(null); // {id, nombre, linea_id}
  const [dupLineaId, setDupLineaId] = useState("");
  const [duplicando, setDuplicando] = useState(false);

  // dialogs
  const [lineaOpen, setLineaOpen] = useState(false);
  // Petición recién creada → abrir «Nueva línea» UNA vez (state de navegación; se limpia con replace para que recargar/volver no reabra)
  const location = useLocation();
  useEffect(() => {
    if (location.state?.abrirLinea && data) {
      setLineaOpen(true);
      nav(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, data]); // eslint-disable-line react-hooks/exhaustive-deps
  const [lineaEditing, setLineaEditing] = useState(null);
  const [validacionFor, setValidacionFor] = useState(null);  // línea para solicitar OK
  const [envioFor, setEnvioFor] = useState(null);  // línea para marcar envío recogido
  const [sinMontajeFor, setSinMontajeFor] = useState(null);  // línea para "Finalizar sin montaje"
  const [cloneOpen, setCloneOpen] = useState(false);
  const [cloneSource, setCloneSource] = useState(null);
  const [cloneEspacioId, setCloneEspacioId] = useState("");
  const [cloneZonaId, setCloneZonaId] = useState("");
  const [compOpen, setCompOpen] = useState(false);
  const [compEditing, setCompEditing] = useState(null);
  // Iter 67 — modal de detalle de componente (reutiliza el del Kanban Mi Producción)
  const [detailComponenteId, setDetailComponenteId] = useState(null);
  const [selectedLineaId, setSelectedLineaId] = useState("");
  // Sep-2026 · paso "Definir producción" tras crear una línea con producción (sin flag persistente)
  const [prodWizard, setProdWizard] = useState(null);   // { linea, n }
  const [prodResumen, setProdResumen] = useState(null); // { linea, n } tras terminar
  const abrirDefinirProduccion = (linea) => {
    setProdResumen(null);
    setProdWizard({ linea, n: 0 });
    setCompEditing(null);
    setCompOpen(true);
  };
  const onLineaCreada = (nueva) => {
    load();
    if (nueva && !lineaEditing && lineaIncluyeProduccion(nueva)) abrirDefinirProduccion(nueva);
  };
  // Sep-2026 — Filtros en pestañas Líneas / Componentes (campañas grandes)
  const [linFiltro, setLinFiltro] = useState({ q: "", estado: "__all__", tipo: "__all__", ciudad: "__all__", provincia: "__all__", montador: "__all__", ruta: "__all__" });
  const [rutasLineas, setRutasLineas] = useState({});
  const [compFiltro, setCompFiltro] = useState({ q: "", estado: "__all__", origen: "__all__", ciudad: "__all__", espacio: "__all__" });
  const [comentario, setComentario] = useState("");
  const [editPeticionOpen, setEditPeticionOpen] = useState(false);

  // Histórico de estados
  const [estadoHistorial, setEstadoHistorial] = useState([]);
  const loadHistorial = useCallback(async () => {
    try {
      const { data } = await api.get(`/peticiones/${id}/estado-historial`);
      setEstadoHistorial(data.items || []);
    } catch (e) { /* no-op */ }
  }, [id]);
  useEffect(() => { loadHistorial(); }, [loadHistorial]);

  const load = useCallback(() => {
    Promise.all([
      api.get(`/peticiones/${id}`),
      api.get("/clientes"), api.get("/espacios"),
      api.get("/materiales"), api.get("/proveedores"),
      api.get("/users"),
    ]).then(([p, c, e, m, pr, u]) => {
      setData(p.data); setClientes(c.data); setEspacios(e.data);
      setMateriales(m.data); setProveedores(pr.data); setUsers(u.data);
    }).catch(() => nav("/peticiones"));
  }, [id, nav]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    api.get(`/peticiones/${id}/reportes-montaje`)
      .then((r) => setReportesMontaje(r.data || {}))
      .catch(() => {});
  }, [id]);

  // Jun-2026 · Contratación cliente (DIAGRAFOS…): una llamada por petición
  const [contratacion, setContratacion] = useState(null);
  const loadContratacion = useCallback(() => {
    if (!id) return;
    api.get(`/peticiones/${id}/contratacion`).then((r) => setContratacion(r.data)).catch(() => setContratacion(null));
  }, [id]);
  useEffect(() => { loadContratacion(); }, [loadContratacion, data?.lineas?.length]);

  const lineaIdsKey = (data?.lineas || []).map((l) => l.id).join(",");
  useEffect(() => {
    if (!lineaIdsKey) { setRutasLineas({}); return; }
    api.get(`/lineas/rutas`, { params: { ids: lineaIdsKey } })
      .then((r) => setRutasLineas(r.data || {}))
      .catch(() => setRutasLineas({}));
  }, [lineaIdsKey]);

  // Iter 55: refrescar listas cuando otra pestaña crea/edita
  // espacios/clientes/cadenas/subclientes (bug "no aparece hasta refrescar")
  const reloadEspacios = useCallback(() => {
    api.get("/espacios").then((e) => setEspacios(e.data || [])).catch(() => {});
  }, []);
  const reloadClientes = useCallback(() => {
    api.get("/clientes").then((c) => setClientes(c.data || [])).catch(() => {});
  }, []);
  const reloadMateriales = useCallback(async () => {
    try {
      const { data } = await api.get("/materiales");
      setMateriales(data || []);
      return data || [];
    } catch { return []; }
  }, []);
  useEntityRefresh("espacio", reloadEspacios);
  useEntityRefresh("cliente", reloadClientes);
  useEntityRefresh("cadena", reloadEspacios);  // las cadenas afectan al combobox de espacios

  // Presupuesto + factura asociados (para flujo de cobro post-entrega)
  const [presu, setPresu] = useState(null);
  const [facturaPet, setFacturaPet] = useState(null);
  useEffect(() => {
    const pid = data?.peticion?.presupuesto_id;
    if (!pid) { setPresu(null); setFacturaPet(null); return; }
    api.get(`/presupuestos/${pid}`).then((r) => setPresu(r.data)).catch(() => setPresu(null));
    api.get("/facturas").then((r) => {
      const f = (r.data || []).find((x) => x.presupuesto_id === pid && x.estado !== "anulada");
      setFacturaPet(f || null);
    }).catch(() => setFacturaPet(null));
  }, [data?.peticion?.presupuesto_id, data?.peticion?.estado]);

  const enviarLinkCobroPet = async () => {
    if (!presu?.id) return;
    try {
      const { data: r } = await api.post(`/presupuestos/${presu.id}/whatsapp-cobro`);
      window.open(r.url, "_blank", "noopener,noreferrer");
      toast.success(`Link de pago enviado · Pendiente ${r.importes.pendiente.toFixed(2)}€`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error generando link de cobro");
    }
  };

  const emitirFacturaPet = async () => {
    if (!presu?.id) return;
    try {
      const { data: f } = await api.post(`/presupuestos/${presu.id}/emitir-factura`);
      setFacturaPet(f);
      toast.success(`Factura ${f.numero} emitida (${f.estado})`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error emitiendo factura");
    }
  };

  if (!data) return <div className="p-8 text-zinc-400">Cargando...</div>;
  const { peticion: p, lineas, componentes, timeline } = data;
  const _norm = (v) => String(v || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const _sel = (f, v) => !f || f === "__all__" || String(v ?? "") === f;
  const lineasVisibles = lineas.filter((l) => {
    const e = espacios.find((x) => x.id === l.espacio_id);
    if (!_sel(linFiltro.estado, l.estado) || !_sel(linFiltro.tipo, l.tipo)) return false;
    if (!_sel(linFiltro.ciudad, e?.ciudad) || !_sel(linFiltro.provincia, e?.provincia)) return false;
    if (linFiltro.montador !== "__all__" && !(l.montador_ids || []).includes(linFiltro.montador)) return false;
    if (linFiltro.ruta && linFiltro.ruta !== "__all__") {
      const ri = rutasLineas[l.id];
      const enRuta = !!ri?.en_ruta, historica = !enRuta && (ri?.historicas?.length > 0);
      if (linFiltro.ruta === "en_ruta" && !enRuta) return false;
      if (linFiltro.ruta === "sin_ruta" && (enRuta || historica)) return false;
      if (linFiltro.ruta === "historica" && !historica) return false;
    }
    if (linFiltro.q) {
      const txt = _norm([e?.nombre, e?.ciudad, e?.provincia, e?.direccion, l.descripcion, l.notas, l.referencia_cliente,
        ...componentes.filter((c) => c.linea_id === l.id).map((c) => `${c.nombre} ${c.referencia_cliente || ""}`)].join(" "));
      if (!_norm(linFiltro.q).split(/\s+/).every((t) => txt.includes(t))) return false;
    }
    return true;
  });
  const componentesVisibles = componentes.filter((c) => {
    const l = lineas.find((x) => x.id === c.linea_id);
    const e = l && espacios.find((x) => x.id === l.espacio_id);
    const padre = c.parent_id ? componentes.find((x) => x.id === c.parent_id) : null;
    const base = padre || c;
    if (!_sel(compFiltro.estado, base.estado) || !_sel(compFiltro.origen, base.origen)) return false;
    if (!_sel(compFiltro.ciudad, e?.ciudad) || !_sel(compFiltro.espacio, e?.nombre)) return false;
    if (compFiltro.q) {
      const txt = _norm([base.nombre, base.descripcion, base.descripcion_encargo, base.referencia_cliente, l?.referencia_cliente,
        base.material?.nombre, e?.nombre, e?.ciudad, c.nombre].join(" "));
      if (!_norm(compFiltro.q).split(/\s+/).every((t) => txt.includes(t))) return false;
    }
    return true;
  });
  const cli = clientes.find((c) => c.id === p.cliente_id);
  const comercial = users.find((u) => u.id === p.comercial_id);
  const disenador = users.find((u) => u.id === p.disenador_id);
  const est = ESTADO_PETICION[p.estado] || ESTADO_PETICION.borrador;

  // Totales calculados desde backend
  const totalPresup = p.presupuesto_calculado || 0;
  const totalCostes = p.coste_calculado || 0;
  const margen = p.margen_calculado || 0;
  const pendAaff = p.componentes_pendientes_aaff || 0;

  const cambiarEstado = async (nuevo) => {
    try {
      await api.patch(`/peticiones/${id}`, { estado: nuevo });
    } catch (e) {
      const d = e?.response?.data?.detail;
      if (e?.response?.status === 409 && d?.code === "peticion_con_no_realizada_pendiente") {
        toast.error(d.msg, { duration: 10000, action: { label: "Resolver en No realizadas", onClick: () => nav("/no-realizadas") } });
        return;
      }
      toast.error(d?.msg || (typeof d === "string" ? d : null) || "No se pudo cambiar el estado");
      return;
    }
    broadcastEntityChange("peticion", { id, estado: nuevo });
    load();
  };

  // Iter 73 — Finalizar petición a mano (cancelación / cierre)
  const abrirFinalizar = async () => {
    setOpenFinalizar(true);
    try {
      const { data } = await api.get(`/peticiones/${id}/cargos-estimados`);
      setCargosEstim(data);
      setFinCargos(data.total_sugerido > 0 ? String(data.total_sugerido) : "");
    } catch (e) {
      toast.error("Error calculando cargos");
    }
  };

  const ejecutarFinalizar = async () => {
    if (!finMotivo.trim()) { toast.error("Indica un motivo"); return; }
    setFinalizando(true);
    try {
      await api.post(`/peticiones/${id}/finalizar`, {
        motivo: finMotivo.trim(),
        motivo_corto: finMotivoCorto,
        cargos_estimados: finCargos ? parseFloat(finCargos) : null,
        notas: finNotas.trim() || null,
      });
      toast.success("Petición finalizada");
      broadcastEntityChange("peticion", { id, estado: "cancelada_manual" });
      setOpenFinalizar(false);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error finalizando");
    } finally {
      setFinalizando(false);
    }
  };

  const enviarComentario = async () => {
    if (!comentario.trim()) return;
    await api.post("/timeline", { peticion_id: id, tipo: "comentario", descripcion: comentario });
    setComentario("");
    load();
  };

  return (
    <div className="p-8 max-w-[1800px]">
      <Link to="/peticiones" className="inline-flex items-center text-xs text-zinc-400 hover:text-amber-300 mb-3" data-testid="back-to-peticiones">
        <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Volver a peticiones
      </Link>

      <div className="flex items-start justify-between border-b border-zinc-800/70 pb-6 mb-6">
        <div className="min-w-0 flex-1 flex items-start gap-4">
          <HeaderImagen p={p} cli={cli} onSaved={load} />
          <div className="min-w-0 flex-1">
          <div className="flex items-center gap-3 flex-wrap mb-2">
            <h1 className="text-2xl font-bold text-zinc-50 truncate" data-testid="peticion-title">{p.nombre}</h1>
            <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${est.color}`}>{est.label}</span>
          </div>
          <OrigenPresupuestoParcial p={p} canValidar={hasRole(["admin", "comercial", "produccion"])} onChanged={load} />
          <div className="text-sm text-zinc-400 flex items-center gap-4 flex-wrap">
            <span><span className="text-zinc-500">Cliente:</span> <span className="text-zinc-200">{cli?.nombre || "—"}</span></span>
            <span><span className="text-zinc-500">Código:</span> <span className="text-amber-300 font-mono font-semibold">{p.codigo || "—"}</span></span>
            {p.marca && <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-violet-500/15 text-violet-300 border border-violet-500/30">🏷 {p.marca}</span>}
            {comercial && <span><span className="text-zinc-500">Comercial:</span> {comercial.name}</span>}
            {disenador && <span><span className="text-zinc-500">Diseño:</span> {disenador.name}</span>}
            {p.fecha_objetivo && <span><span className="text-zinc-500">Objetivo:</span> {new Date(p.fecha_objetivo).toLocaleDateString("es-ES")}</span>}
            <span className="text-amber-300"><span className="text-zinc-500">Presupuesto:</span> {totalPresup.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</span>
            {pendAaff > 0 && <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-red-500/15 text-red-300 border border-red-500/30">⏳ {pendAaff} AAFF pend.</span>}
          </div>
          {p.descripcion && <div className="text-sm text-zinc-300 mt-3 max-w-3xl">{p.descripcion}</div>}
          </div>
        </div>
        <div className="ml-4 flex flex-col gap-2 items-end">
          <div>
            <Label className="text-xs text-zinc-500">Cambiar estado</Label>
            <ChipSelect
              value={p.estado}
              onChange={cambiarEstado}
              data-testid="peticion-estado-select"
              // Flujo v2 — sólo estados manuales (Fernando 31/05/26). Si el estado actual ya
              // es uno automático (en_produccion, en_ruta…) lo incluimos para que sea visible
              // pero no se puede pasar a otro auto manualmente.
              options={(ESTADOS_PETICION_SELECCIONABLES.includes(p.estado)
                ? ESTADOS_PETICION_SELECCIONABLES
                : [p.estado, ...ESTADOS_PETICION_SELECCIONABLES]
              ).map((k) => ({ value: k, label: (ESTADO_PETICION[k]?.label) || k }))}
            />
          </div>
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-edit-btn"
            onClick={() => setEditPeticionOpen(true)}
            className="text-zinc-400 hover:text-amber-300 text-xs h-7 px-2 mt-1"
          >
            <Pencil className="w-3 h-3 mr-1" /> Editar
          </Button>
          {(hasRole("admin") || hasRole("logistica")) && <DiagnosticoRutabilidadButton peticionId={p.id} className="mt-1" />}
          {p.estado !== "cancelada_manual" && p.estado !== "finalizada_manual" && p.estado !== "facturada" && (
            <Button size="sm" variant="ghost"
              data-testid="peticion-finalizar-btn"
              onClick={abrirFinalizar}
              className="text-rose-300 hover:text-rose-200 hover:bg-rose-500/10 text-xs h-7 px-2 mt-1">
              <AlertCircle className="w-3 h-3 mr-1" /> Finalizar a mano
            </Button>
          )}
          {p.estado !== "entregada" && p.estado !== "cancelada_manual" && (
            <Button size="sm" variant="ghost"
              data-testid="peticion-montado-pin-btn"
              onClick={() => setMontadoTarget({ tipo: "peticion", id: p.id })}
              title="Marcar la petición como MONTADA con PIN de supervisor"
              className="text-emerald-300 hover:text-emerald-200 hover:bg-emerald-500/10 text-xs h-7 px-2 mt-1">
              ✅ Montado (PIN)
            </Button>
          )}
          {p.estado === "cancelada_manual" && p.cierre_manual && (
            <span data-testid="peticion-finalizada-badge"
              className="px-2 py-0.5 text-[10px] rounded bg-rose-500/15 text-rose-300 border border-rose-500/30 mt-1.5"
              title={`Motivo: ${p.cierre_manual.motivo}\nPor: ${p.cierre_manual.por_nombre || "—"}`}>
              CANCELADA · {p.cierre_manual.motivo?.slice(0, 30)}…
            </span>
          )}
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-duplicar-btn"
            onClick={async () => {
              // Sugerir un nombre por defecto basado en el original
              const defaultNombre = p.nombre ? `${p.nombre} (copia)` : "";
              const nuevoNombre = window.prompt(
                "Nombre de la NUEVA petición:\n\nDeja vacío para usar el predeterminado.\nLa copia se creará en estado 'borrador' con todas las líneas y componentes.",
                defaultNombre,
              );
              // null = canceló; "" o string = continúa
              if (nuevoNombre === null) return;
              const body = nuevoNombre.trim() ? { nombre: nuevoNombre.trim() } : {};
              const { data } = await api.post(`/peticiones/${p.id}/duplicar`, body);
              nav(`/peticiones/${data.id}`);
            }}
            className="text-zinc-400 hover:text-amber-300 text-xs h-7 px-2 mt-1"
          >
            <Copy className="w-3 h-3 mr-1" /> Duplicar
          </Button>
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-marcar-aaff-btn"
            onClick={async () => {
              if (!window.confirm("¿Marcar TODOS los componentes como 'AAFF recibido'?")) return;
              const { data } = await api.post(`/peticiones/${p.id}/marcar-todos-aaff`);
              alert(`${data.marcados} componentes marcados`);
              load();
            }}
            className="text-zinc-400 hover:text-emerald-300 text-xs h-7 px-2"
            title="Marca de golpe todos los componentes como 'AAFF recibido' (útil cuando ya tienes todos los artes)"
          >
            <CheckCircle2 className="w-3 h-3 mr-1" /> Marcar todos AAFF
          </Button>
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-imprimir-qrs-btn"
            onClick={() => {
              // Iter 84 — auth header obligatorio. window.open directo daba "No autenticado".
              const token = localStorage.getItem("dnf_access_token");
              fetch(`${process.env.REACT_APP_BACKEND_URL}/api/peticiones/${p.id}/qrs-a4.pdf`, {
                headers: { Authorization: `Bearer ${token}` },
              })
                .then((r) => r.blob())
                .then((blob) => {
                  const url = URL.createObjectURL(blob);
                  window.open(url, "_blank", "noopener,noreferrer");
                  setTimeout(() => URL.revokeObjectURL(url), 60_000);
                });
            }}
            className="text-zinc-400 hover:text-amber-300 text-xs h-7 px-2"
            title="Generar PDF A4 con todos los QRs de los componentes"
          >
            <Printer className="w-3 h-3 mr-1" /> QRs A4
          </Button>
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-actualizar-correo-btn"
            onClick={() => setShowActualizarCorreo(true)}
            className="text-zinc-400 hover:text-sky-300 text-xs h-7 px-2"
            title="Pega un correo de permiso/confirmación y revisa los cambios propuestos por línea antes de aplicarlos"
          >
            <Send className="w-3 h-3 mr-1" /> Actualizar desde correo
          </Button>
          <ActualizarDesdeCorreoDialog peticionId={id} open={showActualizarCorreo} onClose={() => setShowActualizarCorreo(false)}
            initialRaw={correoInbound?.email_raw} initialAsunto={correoInbound?.subject}
            onApplied={() => { load(); if (correoInbound) api.post(`/inbound/${correoInbound.id}/marcar-aplicado`).catch(() => {}); }} />
          <Popover open={memoriasMenuOpen} onOpenChange={setMemoriasMenuOpen}>
            <PopoverTrigger asChild>
              <Button
                size="sm"
                variant="ghost"
                data-testid="peticion-memorias-btn"
                onClick={() => setMemoriasMenuOpen((v) => !v)}
                className="text-zinc-400 hover:text-cyan-300 text-xs h-7 px-2"
                title="Memorias del proyecto: técnica (cliente), montaje (instaladores) y producción (taller)"
              >
                <Bot className="w-3 h-3 mr-1" /> Memorias ▾
              </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="bg-zinc-950 border-zinc-800 text-zinc-100 w-64 p-1">
              <button data-testid="memoria-tecnica-item"
                onClick={() => { setMemoriasMenuOpen(false); setShowMemoria(true); }}
                className="w-full text-left text-xs px-2 py-2 rounded hover:bg-zinc-800/80">
                📄 Memoria técnica <span className="text-zinc-500">· cliente</span>
              </button>
              <button data-testid="memoria-montaje-item"
                onClick={() => { setMemoriasMenuOpen(false); setShowMemoriaMontaje(true); }}
                className="w-full text-left text-xs px-2 py-2 rounded hover:bg-zinc-800/80">
                🔧 Memoria de montaje <span className="text-zinc-500">· instaladores</span>
              </button>
              <button data-testid="memoria-produccion-item"
                onClick={async () => {
                  setMemoriasMenuOpen(false);
                  try {
                    const r = await api.get(`/peticiones/${id}/memoria-produccion/pdf`, { responseType: "blob" });
                    const url = URL.createObjectURL(r.data);
                    window.open(url, "_blank", "noopener,noreferrer");
                    setTimeout(() => URL.revokeObjectURL(url), 60000);
                  } catch (e) { toast.error("Error generando el PDF de producción"); }
                }}
                className="w-full text-left text-xs px-2 py-2 rounded hover:bg-zinc-800/80">
                🏭 Memoria de producción <span className="text-zinc-500">· taller</span>
              </button>
            </PopoverContent>
          </Popover>
          <Button
            size="sm"
            variant="ghost"
            data-testid="peticion-delete-btn"
            onClick={async () => {
              const motivo = window.prompt("Para eliminar la petición indica el motivo:\n(esta acción borrará líneas, componentes, timeline y notificaciones asociadas)");
              if (!motivo || !motivo.trim()) return;
              if (!window.confirm(`¿Confirmar eliminación?\n\nPetición: ${p.codigo || p.nombre}\nMotivo: ${motivo}\n\nNo se puede deshacer.`)) return;
              try {
                await api.post(`/timeline`, { peticion_id: p.id, tipo: "eliminacion", descripcion: `Eliminada: ${motivo}` });
              } catch (e) {
                // Si falla el log de timeline, igual procedemos a borrar (el motivo queda como comentario en UI)
                console.warn("No se pudo registrar motivo en timeline:", e?.message);
              }
              await api.delete(`/peticiones/${p.id}`);
              nav("/peticiones");
            }}
            className="text-zinc-500 hover:text-red-400 text-xs h-7 px-2 mt-1"
          >
            <Trash2 className="w-3 h-3 mr-1" /> Eliminar petición
          </Button>
        </div>
      </div>

      {/* Sep 2026 · Origen del correo (creación + actualizaciones por correo) */}
      <OrigenCorreoBlock peticion={data?.peticion} />

      {/* AAFF del cliente */}
      <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-3 mb-4 flex flex-wrap items-center gap-2" data-testid="aaff-bar">
        <span className="text-[11px] uppercase tracking-wider text-violet-300 font-semibold">AAFF del cliente:</span>
        {p.aaff_url ? (
          <a href={p.aaff_url} target="_blank" rel="noreferrer"
            data-testid="aaff-link"
            className="text-xs text-cyan-300 hover:text-cyan-200 underline break-all">{p.aaff_url}</a>
        ) : (
          <span className="text-xs text-zinc-500 italic">Sin enlace</span>
        )}
        {p.aaff_notas && <span className="text-xs text-zinc-400">· {p.aaff_notas}</span>}
        <Button size="sm" variant="ghost" data-testid="aaff-edit-btn"
          onClick={async () => {
            const url = window.prompt("Enlace de los AAFF (WeTransfer, Drive, Mega…):", p.aaff_url || "");
            if (url === null) return;
            const notas = window.prompt("Notas (opcional, ej. 'logos en alta', 'esperando v2'):", p.aaff_notas || "");
            await api.patch(`/peticiones/${p.id}`, { aaff_url: url || null, aaff_notas: notas || null });
            load();
          }}
          className="text-xs text-violet-300 hover:text-violet-200 ml-auto h-6 px-2">
          <Pencil className="w-3 h-3 mr-1" /> {p.aaff_url ? "Editar" : "Añadir enlace"}
        </Button>
      </div>

      <AdjuntosBlock
        peticionId={p.id}
        adjuntos={p.adjuntos || []}
        onChange={() => load()}
      />

      <PortalStatusWidget peticionId={p.id} />

      {/* Banner ENTREGA + COBRO — sólo cuando la petición está entregada y hay factura */}
      {p.estado === "entregada" && facturaPet && (() => {
        const total = Number(facturaPet.totales?.total || 0);
        const pagado = Number(facturaPet.importe_pagado || 0);
        const pendiente = Math.max(total - pagado, 0);
        const cobrada = facturaPet.estado === "cobrada" || pendiente < 0.01;
        const base = process.env.REACT_APP_BACKEND_URL;
        return (
          <div className={`mb-6 rounded-xl p-5 border-2 ${cobrada ? "bg-emerald-500/10 border-emerald-500/40" : "bg-amber-500/10 border-amber-500/50"}`}
               data-testid="banner-entrega-cobro">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="text-3xl">{cobrada ? "🎉" : "🏁"}</div>
                <div className="flex-1 min-w-0">
                  <div className={`text-base font-bold ${cobrada ? "text-emerald-200" : "text-amber-200"}`}>
                    {cobrada ? "Proyecto finalizado · COBRADO" : "Proyecto finalizado · pendiente de cobro"}
                  </div>
                  <div className="text-xs text-zinc-400 mt-1">
                    Factura <Link to={`/facturas`} className="font-mono font-bold text-amber-300 hover:underline" data-testid="link-factura-numero">{facturaPet.numero}</Link> ·{" "}
                    Total: <b className="text-zinc-200">{total.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</b> ·{" "}
                    Pagado: <b className="text-emerald-300">{pagado.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</b>
                    {!cobrada && (<> · Pendiente: <b className="text-amber-300">{pendiente.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</b></>)}
                  </div>
                </div>
              </div>
              <div className="flex gap-2 flex-wrap">
                <Button size="sm" variant="outline" data-testid="btn-descargar-factura-peticion"
                  onClick={() => {
                    const token = localStorage.getItem("access_token");
                    fetch(`${base}/api/facturas/${facturaPet.id}/pdf`, { headers: { Authorization: `Bearer ${token}` } })
                      .then(r => r.blob()).then(blob => {
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a"); a.href = url; a.download = `${facturaPet.numero}.pdf`; a.click();
                        URL.revokeObjectURL(url);
                      });
                  }}
                  className="border-amber-500/40 text-amber-200 hover:bg-amber-500/10">
                  📄 Descargar factura
                </Button>
                {!cobrada && (
                  <Button size="sm" data-testid="btn-solicitar-cobro-peticion"
                    onClick={enviarLinkCobroPet}
                    className="bg-amber-500 hover:bg-amber-600 text-zinc-950 font-bold">
                    💰 Solicitar pago restante
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Banner ENTREGA sin factura (corner case) — botón emitir factura manual */}
      {p.estado === "entregada" && !facturaPet && presu && (
        <div className="mb-6 rounded-xl p-4 border border-zinc-700 bg-zinc-900/50 flex items-center justify-between gap-3 flex-wrap"
             data-testid="banner-emitir-factura">
          <div className="text-sm">
            <span className="text-zinc-200 font-semibold">Petición entregada</span>
            <span className="text-zinc-500 ml-2">— aún no se ha emitido factura.</span>
          </div>
          <Button size="sm" onClick={emitirFacturaPet} data-testid="btn-emitir-factura-manual"
            className="bg-amber-500 hover:bg-amber-600 text-zinc-950 font-bold">
            🧾 Emitir factura ahora
          </Button>
        </div>
      )}

      {/* === Agendar Cita de Montaje === */}
      <PropuestaMontajeBanner peticion={p} onChange={load} />
      <FeedbackBanner peticion={p} onChange={load} />
      <ParteMontajeBanner peticion={p} onChange={load} />
      <FacturaFDBanner peticion={p} onChange={load} />

      <Tabs defaultValue="lineas" className="w-full">
        <TabsList className="bg-zinc-900/60 border border-zinc-800">
          <TabsTrigger value="lineas" data-testid="tab-lineas" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <Wrench className="w-3.5 h-3.5 mr-2" />Líneas de trabajo ({lineas.length})
          </TabsTrigger>
          <TabsTrigger value="componentes" data-testid="tab-componentes" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <Boxes className="w-3.5 h-3.5 mr-2" />Componentes ({componentes.length})
          </TabsTrigger>
          <TabsTrigger value="economico" data-testid="tab-economico" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <Euro className="w-3.5 h-3.5 mr-2" />Económico
          </TabsTrigger>
          <TabsTrigger value="gastos" data-testid="tab-gastos" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <Receipt className="w-3.5 h-3.5 mr-2" />Gastos
          </TabsTrigger>
          <TabsTrigger value="timeline" data-testid="tab-timeline" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <Clock className="w-3.5 h-3.5 mr-2" />Timeline
          </TabsTrigger>
          <TabsTrigger value="historial" data-testid="tab-historial" className="data-[state=active]:bg-amber-500/20 data-[state=active]:text-amber-300">
            <History className="w-3.5 h-3.5 mr-2" />Histórico estados
          </TabsTrigger>
        </TabsList>

        {/* === LINEAS === */}
        <TabsContent value="lineas" className="mt-4">
          <div className="flex justify-end mb-4">
            {/* Wizard "Definir producción": MISMO formulario de componente, montado junto a las líneas (pestaña por defecto) */}
            {prodWizard && (
              <NuevoComponenteDialog open={compOpen} setOpen={setCompOpen} hideTrigger
                lineas={lineas.some((l) => l.id === prodWizard.linea.id) ? lineas : [...lineas, prodWizard.linea]} espacios={espacios}
                materiales={materiales} proveedores={proveedores} onCreated={load}
                onMaterialesChanged={reloadMateriales}
                editing={null} onClose={() => { setProdWizard(null); setCompOpen(false); }}
                wizard={{
                  linea: prodWizard.linea, n: prodWizard.n,
                  onGuardado: () => setProdWizard((w) => (w ? { ...w, n: w.n + 1 } : w)),
                  onTerminar: (nExtra = 0) => { setProdResumen({ linea: prodWizard.linea, n: prodWizard.n + nExtra }); setProdWizard(null); },
                  onMasTarde: () => setProdWizard(null),
                }} />
            )}
            <NuevaLineaDialog open={lineaOpen} setOpen={setLineaOpen} peticionId={id}
              espacios={espacios} users={users} onCreated={onLineaCreada}
              clienteId={data?.cliente_id || null}
              fechaObjetivoDefault={data?.fecha_objetivo ? data.fecha_objetivo.slice(0, 10) : ""}
              editing={lineaEditing} onClose={() => setLineaEditing(null)} />
          </div>
          {validacionFor && (
            <SolicitarValidacionDialog
              open={!!validacionFor}
              linea={validacionFor}
              iteracion={(validacionFor.validacion_iteracion || 0) + 1}
              onClose={() => setValidacionFor(null)}
              onSubmitted={() => { setValidacionFor(null); load(); }}
            />
          )}
          <EnvioRecogidoDialog
            linea={envioFor}
            onClose={() => setEnvioFor(null)}
            onSuccess={() => { setEnvioFor(null); load(); }}
          />
          <FinalizarSinMontajeDialog linea={sinMontajeFor} open={!!sinMontajeFor} onOpenChange={(o) => !o && setSinMontajeFor(null)} onDone={() => load()} />
          {lineas.length > 0 && (
            <FiltrosBar value={linFiltro} onChange={setLinFiltro} testId="filtros-lineas"
              placeholder="Buscar espacio, ciudad, ref. cliente, componente…"
              total={lineas.length} visibles={lineasVisibles.length}
              selects={[
                { k: "estado", placeholder: "Estado", options: uniqOptions(lineas, (l) => l.estado) },
                { k: "tipo", placeholder: "Tipo", options: uniqOptions(lineas, (l) => l.tipo, (v) => TIPO_LINEA[v]?.label || v) },
                { k: "ciudad", placeholder: "Ciudad", options: uniqOptions(lineas, (l) => espacios.find((e) => e.id === l.espacio_id)?.ciudad) },
                { k: "provincia", placeholder: "Provincia", options: uniqOptions(lineas, (l) => espacios.find((e) => e.id === l.espacio_id)?.provincia) },
                { k: "montador", placeholder: "Montador", options: uniqOptions(lineas.flatMap((l) => l.montador_ids || []), (id) => id, (id) => users.find((u) => u.id === id)?.name || id) },
                { k: "ruta", placeholder: "Ruta", options: [
                  { v: "en_ruta", label: `En ruta (${lineas.filter((l) => rutasLineas[l.id]?.en_ruta).length})` },
                  { v: "sin_ruta", label: `Sin ruta (${lineas.filter((l) => !rutasLineas[l.id]?.en_ruta && !(rutasLineas[l.id]?.historicas?.length > 0)).length})` },
                  { v: "historica", label: `Solo histórico (${lineas.filter((l) => !rutasLineas[l.id]?.en_ruta && rutasLineas[l.id]?.historicas?.length > 0).length})` },
                ] },
              ]} />
          )}
          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl overflow-hidden">
            {lineas.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm">Sin líneas. Añade la primera.</div>}
            {lineas.length > 0 && lineasVisibles.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm" data-testid="lineas-sin-coincidencias">Ninguna línea coincide con los filtros.</div>}
            {/* Iter 58 — mini-fila de totales globales de TODAS las líneas */}
            {lineas.length > 0 && (() => {
              const totMontaje = lineas.reduce((acc, l) => acc + (l.precio_montaje || 0), 0);
              const totCosteMontaje = lineas.reduce((acc, l) => acc + (l.coste_montaje || 0), 0);
              const totDiseno = lineas.reduce((acc, l) => acc + (l.precio_diseno || 0), 0);
              const totProd = componentes.reduce((acc, c) => acc + (c.precio_unitario || 0) * (c.cantidad || 0), 0);
              const totCosteProd = componentes.reduce((acc, c) => acc + (c.coste_unitario || 0) * (c.cantidad || 0), 0);
              const totalVenta = totMontaje + totDiseno + totProd;
              const totalCoste = totCosteMontaje + totCosteProd;
              const margenAbs = totalVenta - totalCoste;
              const margenPct = totalVenta > 0 ? (margenAbs / totalVenta) * 100 : 0;
              const colorMargen = margenPct < 20 ? "text-red-300" : margenPct < 35 ? "text-amber-300" : "text-emerald-300";
              return (
                <div className="bg-gradient-to-r from-zinc-900 via-zinc-900/60 to-zinc-900 border-b border-zinc-800 px-4 py-2.5 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs" data-testid="lineas-totales-bar">
                  <span className="text-zinc-500 font-medium uppercase tracking-wider text-[10px]">📊 Totales petición</span>
                  <span className="text-zinc-400">Montaje: <b className="text-amber-300">{totMontaje.toFixed(2)} €</b></span>
                  {totDiseno > 0 && <span className="text-zinc-400">Diseño: <b className="text-violet-300">{totDiseno.toFixed(2)} €</b></span>}
                  <span className="text-zinc-400">Producción: <b className="text-emerald-300">{totProd.toFixed(2)} €</b></span>
                  <span className="text-zinc-300 border-l border-zinc-700 pl-6 ml-2">Venta total: <b className="text-zinc-100">{totalVenta.toFixed(2)} €</b></span>
                  <span className="text-zinc-500">Coste: <b className="text-zinc-400">{totalCoste.toFixed(2)} €</b></span>
                  <span className="ml-auto" data-testid="margen-total">
                    Margen: <b className={`${colorMargen} font-mono`}>{margenAbs.toFixed(2)} € ({margenPct.toFixed(1)}%)</b>
                  </span>
                </div>
              );
            })()}
            {prodResumen && (() => {
              const l = prodResumen.linea; const esp = espacios.find((e) => e.id === l.espacio_id);
              const comps = componentes.filter((c) => c.linea_id === l.id && !c.parent_id);
              const uds = comps.reduce((a, c) => a + (Number(c.cantidad) || 0), 0);
              return (
                <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-4 py-3 flex flex-wrap items-center gap-3 text-sm" data-testid="linea-creada-resumen">
                  <CheckCircle2 className="w-4 h-4 text-emerald-300" />
                  <div className="flex-1 min-w-[200px]">
                    <div className="font-semibold text-emerald-100">Línea creada · {esp?.nombre || "Sin espacio"}</div>
                    <div className="text-xs text-emerald-200/80">{(l.tipos || [l.tipo]).filter(Boolean).join(" + ")} · {comps.length} componente{comps.length === 1 ? "" : "s"} · {uds} uds</div>
                  </div>
                  <Button size="sm" variant="outline" className="h-7 text-xs bg-transparent border-zinc-700" data-testid="linea-creada-editar" onClick={() => { setProdResumen(null); setLineaEditing(lineas.find((x) => x.id === l.id) || l); setLineaOpen(true); }}>Editar</Button>
                  <Button size="sm" variant="outline" className="h-7 text-xs bg-transparent border-zinc-700" data-testid="linea-creada-otra" onClick={() => { setProdResumen(null); setLineaEditing(null); setLineaOpen(true); }}>Crear otra línea</Button>
                  <Button size="sm" className="h-7 text-xs bg-emerald-500 text-zinc-900 hover:bg-emerald-400" data-testid="linea-creada-terminar" onClick={() => setProdResumen(null)}>Terminar</Button>
                </div>
              );
            })()}
            {lineasVisibles.map((l) => {
              const esp = espacios.find((e) => e.id === l.espacio_id);
              const zona = esp?.zonas?.find((z) => z.id === l.zona_id);
              const tipo = TIPO_LINEA[l.tipo] || TIPO_LINEA.solo_montaje;
              const lineaMontadores = users.filter((u) => (l.montador_ids || []).includes(u.id));
              const compsLinea = componentes.filter((c) => c.linea_id === l.id && !c.parent_id);
              const totalCompsLinea = componentes.filter((c) => c.linea_id === l.id).length;
              const totalCosteProd = componentes.filter((c) => c.linea_id === l.id)
                .reduce((acc, c) => acc + (c.coste_unitario || 0) * (c.cantidad || 0), 0);
              const totalPrecioProd = componentes.filter((c) => c.linea_id === l.id)
                .reduce((acc, c) => acc + (c.precio_unitario || 0) * (c.cantidad || 0), 0);
              const retiradaVinculada = lineas.find((x) => x.retirada_de_linea_id === l.id);
              const esRetirada = !!l.retirada_de_linea_id;
              return (
                <div key={l.id} id={`linea-${l.id}`} data-testid={`linea-row-${l.id}`}
                  className={`p-4 border-b border-zinc-800/60 last:border-b-0 ${esRetirada ? "bg-orange-500/[0.02] border-l-2 border-l-orange-500/40" : ""} ${l.es_revisita ? "bg-cyan-500/[0.04] border-l-2 border-l-cyan-500/50" : ""}`}>
                  <div className="flex items-center justify-between flex-wrap gap-3">
                    <div className="flex items-center gap-3 flex-wrap">
                      <ProyectoThumb url={l.imagen_url} nombre={esp?.nombre || cli?.nombre || "?"} size={32} rounded="lg"
                        data-testid={`linea-thumb-${l.id}`} />
                      <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${tipo.color}`}>{tipo.label}</span>
                      {l.es_revisita && (
                        <span
                          data-testid={`revisita-badge-${l.id}`}
                          title={l.notas_revisita || ""}
                          className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-cyan-500/20 text-cyan-200 border border-cyan-500/40 font-bold">
                          🔁 Revisita {l.tipo_revisita ? `· ${l.tipo_revisita}` : ""}
                        </span>
                      )}
                      <span className="text-sm font-medium text-zinc-100">{esp?.nombre || "Sin espacio"}</span>
                      {zona && <span className="text-xs text-amber-300/80">↳ {zona.nombre} {zona.ancho_cm && zona.alto_cm ? `(${zona.ancho_cm}×${zona.alto_cm}cm)` : ""}</span>}
                      {l.requisitos_montaje && <RequisitosChips req={l.requisitos_montaje} testId={`linea-card-req-${l.id}`} />}
                      <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${ESTADO_LINEA[l.estado] || ESTADO_LINEA.pendiente}`}>{l.estado}</span>
                      {lineaIncluyeProduccion(l) && (() => {
                        const cs = componentes.filter((c) => c.linea_id === l.id && !c.parent_id);
                        if (cs.length === 0) return (
                          <button type="button" data-testid={`linea-prod-pendiente-${l.id}`} onClick={() => abrirDefinirProduccion(l)}
                            title="Esta línea incluye producción pero aún no tiene componentes. Pulsa para definirla."
                            className="text-[10px] px-2 py-1 rounded bg-red-500/10 text-red-200 border border-red-500/40 hover:bg-red-500/20">
                            ⚠ Producción pendiente de definir
                          </button>
                        );
                        const uds = cs.reduce((a, c) => a + (Number(c.cantidad) || 0), 0);
                        return <span data-testid={`linea-prod-resumen-${l.id}`} className="text-[10px] px-2 py-1 rounded bg-zinc-800 text-zinc-300 border border-zinc-700">{cs.length} componente{cs.length === 1 ? "" : "s"} · {uds} uds</span>;
                      })()}
                      {l.referencia_cliente && (
                        <span data-testid={`linea-ref-cliente-${l.id}`} title="Referencia / nº pedido del cliente"
                          className="text-[10px] px-2 py-1 rounded bg-amber-500/10 text-amber-200 border border-amber-500/30 font-mono">
                          Ref. {l.referencia_cliente}
                        </span>
                      )}
                      {(reportesMontaje[l.id] || []).length > 0 && (() => {
                        const visitas = reportesMontaje[l.id];
                        const ult = visitas[visitas.length - 1];
                        const cfg = {
                          montado: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
                          semi_montado: "bg-amber-500/15 text-amber-300 border-amber-500/40",
                          incidencia: "bg-red-500/15 text-red-300 border-red-500/40",
                          cancelado: "bg-zinc-700/40 text-zinc-300 border-zinc-600",
                        }[ult.estado_cierre] || "bg-zinc-700/40 text-zinc-300 border-zinc-600";
                        const lbl = ult.estado_cierre === "incidencia" ? "Incidencia"
                          : ult.estado_cierre === "semi_montado" ? "Semi montado"
                          : ult.estado_cierre === "cancelado" ? "Cancelado" : "Reporte";
                        return (
                          <button onClick={() => setReporteModal({ visitas, espacioNombre: esp?.nombre })}
                            data-testid={`ver-reporte-btn-${l.id}`}
                            title="Ver reporte de montaje: fotos, estado del cierre e incidencias"
                            className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded border font-bold inline-flex items-center gap-1 hover:brightness-125 transition-[filter] ${cfg}`}>
                            📷 {lbl}{visitas.length > 1 ? ` (${visitas.length})` : ""}
                          </button>
                        );
                      })()}
                      <EnRutaBadge info={rutasLineas[l.id]} lineaId={l.id} lineaRef={l.referencia_cliente} />
                      {contratacion?.aplica && contratacion.lineas?.[l.id] && <EstadoContratacionBadge ev={contratacion.lineas[l.id]} testId={`linea-contratacion-badge-${l.id}`} />}
                      {l.estado === "agendada" && l.agendada_en_ruta_id && Object.keys(rutasLineas).length === 0 && (
                        <span data-testid={`agendada-badge-${l.id}`}
                          className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-indigo-500/15 text-indigo-300 border border-indigo-500/30 inline-flex items-center gap-1"
                          title="Esta línea está en una ruta planificada — no se ofrecerá para enrutar de nuevo">
                          🗓️ En ruta
                        </span>
                      )}
                      {l.estado === "cerrada_sin_montaje" && (
                        <span data-testid={`cerrada-sin-montaje-badge-${l.id}`}
                          className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-amber-500/15 text-amber-300 border border-amber-500/30 inline-flex items-center gap-1"
                          title={`${l.cierre_sin_montaje?.motivo_label || "Cierre sin montaje"} · ${l.cierre_sin_montaje?.usuario || ""} · albarán ${l.cierre_sin_montaje?.albaran_numero || "?"}${l.cierre_sin_montaje?.fd_delivery_note_number ? ` · FD ${l.cierre_sin_montaje.fd_delivery_note_number}` : ""}`}>
                          📦 Cerrada sin montaje · {l.cierre_sin_montaje?.albaran_numero || "albarán"}
                        </span>
                      )}
                      {l.estado === "enviado" && (
                        <span data-testid={`enviado-badge-${l.id}`}
                          className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-fuchsia-500/15 text-fuchsia-300 border border-fuchsia-500/30 inline-flex items-center gap-1"
                          title={`${l.transportista || "transportista"} · ${l.tracking_envio || "sin tracking"}`}>
                          📦 Enviado · {l.transportista || "?"}
                        </span>
                      )}
                      {(l.tipos && l.tipos.length > 0) && (
                        <TiposLineaBadges tipos={l.tipos} compact />
                      )}
                      {(l.fecha_programada || l.fecha_montaje_prevista) && (() => {
                        const fMont = String(l.fecha_programada || l.fecha_montaje_prevista).slice(0, 10);
                        const distinta = p.fecha_objetivo && fMont !== String(p.fecha_objetivo).slice(0, 10);
                        return (
                          <span data-testid={`fecha-montaje-badge-${l.id}`}
                            title={distinta ? "Fecha de montaje distinta de la fecha objetivo de la petición" : "Fecha de montaje de esta línea"}
                            className={`text-[10px] px-2 py-1 rounded border inline-flex items-center gap-1 font-mono ${
                              distinta ? "bg-cyan-500/15 text-cyan-300 border-cyan-500/40" : "bg-zinc-800/80 text-zinc-300 border-zinc-700"}`}>
                            📅 {new Date(fMont + "T00:00:00").toLocaleDateString("es-ES", { day: "numeric", month: "short" })}
                          </span>
                        );
                      })()}
                      {l.fecha_programada && esRetirada && <span className="text-xs text-zinc-500">📅 {new Date(l.fecha_programada).toLocaleDateString("es-ES")}</span>}
                      {l.horas_estimadas && <span className="text-xs text-zinc-500">⏱ {l.horas_estimadas}h est.</span>}
                      {retiradaVinculada && (
                        <span className="text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-orange-500/15 text-orange-300 border border-orange-500/30">
                          ↻ retirada {new Date(retiradaVinculada.fecha_programada).toLocaleDateString("es-ES")}
                        </span>
                      )}
                      {l.requiere_validacion && (
                        <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded inline-flex items-center gap-1 ${
                          l.validacion_estado === "aprobada" ? "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30"
                            : l.validacion_estado === "rechazada" ? "bg-red-500/15 text-red-300 border border-red-500/30"
                            : l.validacion_estado === "pendiente" ? "bg-amber-500/15 text-amber-300 border border-amber-500/30"
                            : "bg-cyan-500/15 text-cyan-300 border border-cyan-500/30"
                        }`} data-testid={`validacion-badge-${l.id}`}>
                          <ShieldCheck className="w-3 h-3" />
                          {l.validacion_estado === "aprobada" ? "Validado"
                            : l.validacion_estado === "rechazada" ? "Rechazado"
                            : l.validacion_estado === "pendiente" ? "Esperando OK"
                            : "Requiere OK"}
                          {l.validacion_iteracion > 1 && ` (#${l.validacion_iteracion})`}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-1">
                      {l.estado !== "completada" && l.estado !== "cerrada_sin_montaje" && (hasRole("admin") || hasRole("comercial") || hasRole("administracion")) && (
                        <Button size="sm" variant="ghost"
                          data-testid={`btn-finalizar-sin-montaje-${l.id}`}
                          onClick={() => setSinMontajeFor(l)}
                          title="Cerrar la línea sin montaje y llevar producción/envío al albarán de FacturaDirecta (sin ruta ni reporte)"
                          className="text-amber-300/80 hover:text-amber-200 hover:bg-amber-500/10 h-7 px-2 text-[11px]">
                          <PackageCheck className="w-3.5 h-3.5 mr-1" /> Sin montaje
                        </Button>
                      )}
                      {l.estado !== "completada" && l.estado !== "cerrada_sin_montaje" && (
                        <Button size="sm" variant="ghost"
                          data-testid={`linea-montado-pin-${l.id}`}
                          onClick={() => setMontadoTarget({ tipo: "linea", id: l.id })}
                          title="Marcar esta línea como MONTADA con PIN de supervisor"
                          className="text-emerald-400/70 hover:text-emerald-300 hover:bg-emerald-500/10 h-7 px-2 text-[11px]">
                          ✅ Montado
                        </Button>
                      )}
                      {l.requiere_validacion && l.validacion_estado !== "aprobada" && (
                        (hasRole("admin") || (l.montador_ids || []).includes(currentUser?.id)) && (
                          <Button size="sm" variant="ghost"
                            onClick={() => setValidacionFor(l)}
                            data-testid={`btn-solicitar-ok-${l.id}`}
                            title={l.validacion_estado === "rechazada" ? "Subir nuevas fotos (intento previo rechazado)" : "Solicitar OK al admin"}
                            className="text-cyan-300 hover:text-cyan-200 hover:bg-cyan-500/10 h-7 px-2 text-xs">
                            <ShieldCheck className="w-3.5 h-3.5 mr-1" />
                            {l.validacion_estado === "rechazada" ? "Re-enviar" : "Solicitar OK"}
                          </Button>
                        )
                      )}
                      {!esRetirada && (
                        <>
                          {/* Marcar envío recogido (sólo flujos de envío) */}
                          {(l.tipo === "produccion_envio" || l.tipo === "diseno_produccion_envio") && l.estado !== "enviado" && (hasRole("admin") || hasRole("administracion")) && (
                            <Button size="sm" variant="ghost"
                              onClick={() => setEnvioFor(l)}
                              data-testid={`btn-envio-recogido-${l.id}`}
                              title="Marcar como recogido por el transportista (dispara albarán automático)"
                              className="text-fuchsia-300 hover:text-fuchsia-200 hover:bg-fuchsia-500/10 h-7 px-2 text-xs">
                              <Truck className="w-3.5 h-3.5 mr-1" /> Envío recogido
                            </Button>
                          )}
                          {/* Imprimir etiqueta de envío (cualquier línea con "envio" en tipo/tipos[]) */}
                          {((l.tipo || "").includes("envio") || ((l.tipos || []).some((t) => (t || "").includes("envio")))) && (
                            <Button size="sm" variant="ghost"
                              onClick={async () => {
                                try {
                                  const { data } = await api.get(`/lineas/${l.id}/etiqueta-envio.pdf`, { responseType: "blob" });
                                  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
                                  window.open(url, "_blank");
                                  setTimeout(() => URL.revokeObjectURL(url), 8000);
                                } catch (e) {
                                  alert("No se pudo generar la etiqueta: " + (e?.response?.data?.detail || e.message));
                                }
                              }}
                              data-testid={`btn-etiqueta-envio-${l.id}`}
                              title="Imprimir etiqueta A6 para pegar en el bulto"
                              className="text-amber-300 hover:text-amber-200 hover:bg-amber-500/10 h-7 px-2 text-xs">
                              <Package className="w-3.5 h-3.5 mr-1" /> Etiqueta
                            </Button>
                          )}
                          <Button size="sm" variant="ghost"
                            onClick={() => { setLineaEditing(l); setLineaOpen(true); }}
                            data-testid={`edit-linea-${l.id}`}
                            className="text-zinc-400 hover:text-amber-300 h-7 px-2">
                            <Pencil className="w-3.5 h-3.5" />
                          </Button>
                          <Button size="sm" variant="ghost"
                            onClick={() => { setCloneSource(l); setCloneEspacioId(""); setCloneZonaId(""); setCloneOpen(true); }}
                            data-testid={`clone-linea-${l.id}`}
                            title="Clonar línea a otro espacio"
                            className="text-zinc-400 hover:text-blue-300 h-7 px-2">
                            <Copy className="w-3.5 h-3.5" />
                          </Button>
                        </>
                      )}
                      <Button size="sm" variant="ghost"
                        onClick={async () => { if (confirm("¿Eliminar línea?" + (retiradaVinculada ? "\nTambién se borrará la retirada vinculada." : ""))) { await api.delete(`/lineas/${l.id}`); load(); } }}
                        className="text-zinc-500 hover:text-red-400 h-7 px-2">
                        <Trash2 className="w-3.5 h-3.5" />
                      </Button>
                    </div>
                  </div>
                  {l.descripcion && <div className="text-sm text-zinc-300 mt-2">{l.descripcion}</div>}
                  <div className="mt-2 empty:hidden"><PermisoCorreoBlock linea={l} testId={`linea-permiso-${l.id}`} /></div>
                  {l.requiere_validacion && l.validacion_estado === "rechazada" && (
                    <div className="mt-2 bg-red-500/10 border border-red-500/30 rounded-md p-2 text-xs text-red-200 flex items-start gap-2">
                      <ShieldAlert className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                      <div>
                        <b>Validación rechazada (intento #{l.validacion_iteracion}).</b> Revisa el motivo en
                        <Link to="/validaciones" className="text-cyan-300 hover:underline ml-1">Validaciones</Link> y
                        re-envía fotos del trabajo corregido.
                      </div>
                    </div>
                  )}
                  {l.notas && <div className="text-xs text-amber-200/70 mt-1.5 italic">📝 {l.notas}</div>}
                  {contratacion?.aplica && <ContratacionClienteBlock lineaId={l.id} ev={contratacion.lineas?.[l.id]} puedeEditar={hasRole("admin") || hasRole("administracion") || hasRole("comercial")} onSaved={loadContratacion} />}
                  {lineaMontadores.length > 0 && (
                    <div className="mt-2 text-xs text-zinc-400">
                      <span className="text-zinc-500">Montadores: </span>
                      {lineaMontadores.map((m) => m.name).join(", ")}
                    </div>
                  )}
                  {(l.precio_montaje > 0 || l.coste_montaje > 0) && (
                    <div className="text-xs text-zinc-500 mt-1">
                      Montaje: <span className="text-amber-300 font-semibold">{(l.precio_montaje || 0).toFixed(2)} €</span>
                      {l.coste_montaje > 0 && <span className="text-zinc-500"> · coste {l.coste_montaje.toFixed(2)} €</span>}
                    </div>
                  )}
                  {totalPrecioProd > 0 && (
                    <div className="text-xs text-zinc-500 mt-1">
                      Producción: <span className="text-emerald-300 font-semibold">{totalPrecioProd.toFixed(2)} €</span>
                      {totalCosteProd > 0 && <span className="text-zinc-500"> · coste {totalCosteProd.toFixed(2)} €</span>}
                    </div>
                  )}
                  {totalCompsLinea > 0 && (
                    <div className="text-xs text-zinc-500 mt-2">
                      {compsLinea.length} componente(s) ({totalCompsLinea} contando sub-piezas)
                    </div>
                  )}
                  {/* Iter 60 — Elementos a montar inline para líneas Solo Montaje */}
                  {(() => {
                    const tipos = Array.isArray(l.tipos) && l.tipos.length > 0 ? l.tipos : (l.tipo ? [l.tipo] : []);
                    const esSoloMontaje = (tipos.length === 1 && (tipos[0] === "montaje" || tipos[0] === "solo_montaje"))
                      || (l.tipo === "solo_montaje" && (!l.tipos || l.tipos.length === 0));
                    if (!esSoloMontaje || esRetirada) return null;
                    const elementosLinea = componentes.filter((c) => c.linea_id === l.id && !c.parent_id);
                    return (
                      <ElementosMontajeInline
                        linea={l}
                        elementos={elementosLinea}
                        onChanged={load}
                      />
                    );
                  })()}
                </div>
              );
            })}
          </div>
          {/* DIÁLOGO CLONAR LÍNEA */}
          <ClonarLineaDialog
            open={cloneOpen} setOpen={setCloneOpen}
            source={cloneSource} espacios={espacios}
            clienteId={data?.cliente_id || null}
            cloneEspacioId={cloneEspacioId} setCloneEspacioId={setCloneEspacioId}
            cloneZonaId={cloneZonaId} setCloneZonaId={setCloneZonaId}
            onCloned={load}
          />
        </TabsContent>

        {/* === COMPONENTES === */}
        <TabsContent value="componentes" className="mt-4">
          {componentes.length > 0 && (() => {
            const espDeComp = (c) => { const l = lineas.find((x) => x.id === c.linea_id); return l && espacios.find((e) => e.id === l.espacio_id); };
            const padresAll = componentes.filter((c) => !c.parent_id);
            return (
              <FiltrosBar value={compFiltro} onChange={setCompFiltro} testId="filtros-componentes"
                placeholder="Buscar componente, ref. cliente, material, espacio…"
                total={padresAll.length} visibles={componentesVisibles.filter((c) => !c.parent_id).length}
                selects={[
                  { k: "estado", placeholder: "Estado", options: uniqOptions(padresAll, (c) => c.estado, (v) => ESTADO_COMPONENTE[v]?.label || v) },
                  { k: "origen", placeholder: "Origen", options: uniqOptions(padresAll, (c) => c.origen, (v) => ORIGEN_LABELS[v]?.label || v) },
                  { k: "ciudad", placeholder: "Ciudad", options: uniqOptions(padresAll, (c) => espDeComp(c)?.ciudad) },
                  { k: "espacio", placeholder: "Espacio", options: uniqOptions(padresAll, (c) => espDeComp(c)?.nombre) },
                ]} />
            );
          })()}
          <div className="flex justify-end mb-4 gap-2">
            <Select value={selectedLineaId} onValueChange={setSelectedLineaId}>
              <SelectTrigger className="w-72 bg-zinc-900 border-zinc-800 h-9 text-xs">
                <SelectValue placeholder="Filtrar por línea" />
              </SelectTrigger>
              <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
                <SelectItem value="all">Todas las líneas</SelectItem>
                {lineas.map((l) => {
                  const esp = espacios.find((e) => e.id === l.espacio_id);
                  return <SelectItem key={l.id} value={l.id}>{(TIPO_LINEA[l.tipo]?.label || l.tipo)} — {esp?.nombre || "—"}</SelectItem>;
                })}
              </SelectContent>
            </Select>
            <NuevoComponenteDialog open={compOpen && !prodWizard} setOpen={setCompOpen} lineas={lineas} espacios={espacios}
              materiales={materiales} proveedores={proveedores} onCreated={load}
              onMaterialesChanged={reloadMateriales}
              editing={compEditing} onClose={() => setCompEditing(null)} />
          </div>
          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl overflow-hidden">
            <div className="grid grid-cols-[2.5fr_1.2fr_0.5fr_0.7fr_0.7fr_1fr] gap-3 px-4 py-2 text-[10px] uppercase tracking-[0.14em] text-zinc-500 border-b border-zinc-800 bg-zinc-950/50">
              <div>Componente</div><div>Origen</div><div>Cant.</div><div>Tamaño</div><div>Precio</div><div>Estado</div>
            </div>
            {(() => {
              const filtered = componentesVisibles.filter((c) => !selectedLineaId || selectedLineaId === "all" || c.linea_id === selectedLineaId);
              const padres = filtered.filter((c) => !c.parent_id);
              const subsByParent = filtered.reduce((acc, c) => {
                if (c.parent_id) {
                  if (!acc[c.parent_id]) acc[c.parent_id] = [];
                  acc[c.parent_id].push(c);
                }
                return acc;
              }, {});
              const huerfanos = filtered.filter((c) => c.parent_id && !padres.some((p) => p.id === c.parent_id));
              const renderRow = (c, isSub = false) => {
                const orig = ORIGEN_LABELS[c.origen] || ORIGEN_LABELS.produccion_propia;
                const precio = (c.precio_unitario || 0) * (c.cantidad || 0);
                // AAFF solo es relevante para componentes que DNF produce internamente
                const aplicaAaff = c.origen === "produccion_propia";
                const aaffPending = aplicaAaff && !c.aaff_recibido;
                const aaffOk = aplicaAaff && c.aaff_recibido;
                // Iter 83 — Mostrar contexto del componente: línea/espacio/ciudad/provincia/marca.
                // El listado antes solo mostraba el nombre, sin saber a qué tienda iba ni de qué marca.
                const lineaComp = lineas.find((l) => l.id === c.linea_id);
                const espComp = lineaComp && espacios.find((e) => e.id === lineaComp.espacio_id);
                const linTipo = lineaComp ? (TIPO_LINEA[lineaComp.tipo]?.label || lineaComp.tipo) : null;
                const ubicacion = [espComp?.ciudad, espComp?.provincia].filter(Boolean).join(" · ");
                const refCli = c.referencia_cliente || lineaComp?.referencia_cliente;
                return (
                  <div key={c.id} data-testid={`componente-row-${c.id}`}
                    className={`grid grid-cols-[2.5fr_1.2fr_0.5fr_0.7fr_0.7fr_1.2fr] gap-3 px-4 py-3 items-center border-b border-zinc-800/60 last:border-b-0 hover:bg-zinc-900/40 ${isSub ? "bg-zinc-950/40 pl-10" : ""}`}>
                    <div className="min-w-0 flex items-center gap-2.5">
                      {isSub && <ChevronRight className="w-3 h-3 text-zinc-600 shrink-0" />}
                      {componenteImgSrc(c, 64, 64) && <img src={componenteImgSrc(c, 64, 64)} alt="" loading="lazy" className="w-8 h-8 rounded object-cover border border-zinc-700 shrink-0" />}
                      <div className="min-w-0">
                        <div className="text-sm text-zinc-100 truncate flex items-center gap-2">
                          {c.nombre}
                          {aaffPending && !isSub && (
                            <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-red-500/20 text-red-300 border border-red-500/40 shrink-0">⏳ AAFF</span>
                          )}
                          {aaffOk && !isSub && (
                            <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 shrink-0">✓ AAFF</span>
                          )}
                        </div>
                        {c.descripcion_encargo && <div className="text-[11px] text-violet-300/70 truncate">📝 {c.descripcion_encargo}</div>}
                        {!c.descripcion_encargo && c.descripcion && <div className="text-[11px] text-zinc-500 truncate">{c.descripcion}</div>}
                        {c.cambio_grafica && <div className="mt-1"><GraficaChip cg={c.cambio_grafica} testId={`componente-grafica-${c.id}`} /></div>}
                        {!isSub && (espComp || p.marca || refCli) && (
                          <div className="flex items-center gap-1.5 mt-1 flex-wrap" data-testid={`componente-contexto-${c.id}`}>
                            {refCli && (
                              <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-200 border border-amber-500/30 font-mono"
                                data-testid={`componente-ref-cliente-${c.id}`}
                                title={c.referencia_cliente ? "Referencia del cliente (componente)" : "Referencia del cliente (heredada de la línea)"}>
                                Ref. {refCli}
                              </span>
                            )}
                            {espComp && (
                              <span className="text-[10px] px-1.5 py-0.5 rounded bg-sky-500/10 text-sky-300 border border-sky-500/30 inline-flex items-center gap-1"
                                title={linTipo ? `${linTipo} · ${espComp.nombre}` : espComp.nombre}>
                                📍 {espComp.nombre}
                              </span>
                            )}
                            {ubicacion && (
                              <span className="text-[10px] px-1.5 py-0.5 rounded bg-zinc-800/60 text-zinc-300 border border-zinc-700"
                                title="Ciudad · Provincia">
                                {ubicacion}
                              </span>
                            )}
                            {p.marca && (
                              <span className="text-[10px] px-1.5 py-0.5 rounded bg-violet-500/10 text-violet-300 border border-violet-500/30"
                                title="Marca">
                                🏷 {p.marca}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <span className={`text-[10px] px-2 py-0.5 rounded border ${orig.color}`}>{orig.icon} {orig.label}</span>
                    </div>
                    <div className="text-xs text-zinc-300">{c.cantidad}</div>
                    <div className="text-xs text-zinc-400">
                      {c.tamano || (c.ancho_cm && c.alto_cm ? `${c.ancho_cm}×${c.alto_cm}cm` : "—")}
                      {c.metros_cuadrados > 0 && (
                        <span className="ml-1 text-emerald-400/80">
                          ({c.metros_cuadrados.toFixed(2)} m²{c.tipo_plantilla === "marco_vinilo" ? " marco" : ""})
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-zinc-100 font-medium">
                      {precio > 0 ? `${precio.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €` : "—"}
                    </div>
                    <div className="flex items-center gap-1 justify-end">
                      {(() => {
                        const est = ESTADO_COMPONENTE[c.estado] || ESTADO_COMPONENTE.pendiente;
                        const u = c.ubicacion_material;
                        const ubicTitle = u === "pdv" ? "Disponible para montar · En punto de venta (no pasa por almacén DNF)"
                          : u === "almacen" ? "Disponible para montar · En almacén DNF"
                          : "Pendiente de recepción · aún no disponible para montar";
                        const ubicCls = u === "pdv" ? "ring-1 ring-sky-400/60" : u === "almacen" ? "ring-1 ring-emerald-400/60" : "";
                        return (
                          <span
                            data-testid={`componente-estado-${c.id}`}
                            data-ubicacion={u || "pendiente"}
                            title={ubicTitle}
                            className={`text-[10px] px-1.5 py-0.5 rounded ${est.color} ${ubicCls}`}
                          >
                            {est.icon} {est.label}{u === "pdv" ? " · PDV" : ""}
                          </span>
                        );
                      })()}
                      {(() => {
                        const next = TRANSICIONES[c.estado] || [];
                        if (next.length === 0) return null;
                        return (
                          <Select
                            value=""
                            onValueChange={async (v) => {
                              if (!v) return;
                              await api.patch(`/componentes/${c.id}`, { estado: v });
                              load();
                            }}
                          >
                            <SelectTrigger
                              data-testid={`componente-workflow-${c.id}`}
                              className="h-6 w-6 p-0 bg-zinc-800/60 border-zinc-700 hover:bg-amber-500/20 [&>svg]:hidden"
                              title="Cambiar estado"
                            >
                              <ChevronRight className="w-3 h-3 text-amber-300" />
                            </SelectTrigger>
                            <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
                              {next.map((k) => {
                                const e = ESTADO_COMPONENTE[k] || { label: k, icon: "→" };
                                return (
                                  <SelectItem key={k} value={k}>
                                    {e.icon} {e.label}
                                  </SelectItem>
                                );
                              })}
                            </SelectContent>
                          </Select>
                        );
                      })()}
                      {(c.bulto_numero || ETIQUETA_ESTADOS.has(c.estado)) && (
                        <Button
                          size="sm"
                          variant="ghost"
                          className="h-6 w-6 p-0 text-emerald-400 hover:text-emerald-300"
                          data-testid={`etiqueta-btn-${c.id}`}
                          onClick={(e) => { e.stopPropagation(); e.preventDefault(); abrirEtiqueta(c.id, "pdf"); }}
                          title={`Imprimir etiqueta${c.bulto_numero ? ` (Bulto ${c.bulto_numero})` : ""}`}
                        >
                          <Tag className="w-3 h-3" />
                        </Button>
                      )}
                      {!isSub && (
                        <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-400 hover:text-cyan-300"
                          data-testid={`detalle-componente-${c.id}`}
                          title="Ver detalle completo + AAFF"
                          onClick={(e) => { e.stopPropagation(); setDetailComponenteId(c.id); }}>
                          <Eye className="w-3 h-3" />
                        </Button>
                      )}
                      {!isSub && (
                        <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-400 hover:text-amber-300"
                          data-testid={`edit-componente-${c.id}`}
                          onClick={() => { setCompEditing(c); setCompOpen(true); }}>
                          <Pencil className="w-3 h-3" />
                        </Button>
                      )}
                      {isSub && (
                        <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-400 hover:text-amber-300"
                          onClick={() => { setCompEditing(c); setCompOpen(true); }}>
                          <Pencil className="w-3 h-3" />
                        </Button>
                      )}
                      {!isSub && (
                        <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-400 hover:text-blue-300"
                          data-testid={`duplicar-componente-${c.id}`}
                          title="Duplicar componente — elegir línea destino"
                          onClick={() => {
                            setDupComp(c);
                            setDupLineaId(c.linea_id || "");
                          }}>
                          <Copy className="w-3 h-3" />
                        </Button>
                      )}
                      {!isSub && (
                        <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-400 hover:text-violet-300"
                          data-testid={`promover-componente-${c.id}`}
                          title="Promover a línea independiente (su propio montaje + reporte)"
                          onClick={async () => {
                            const valor = window.prompt(
                              `Promover "${c.nombre}" a línea independiente.\n\n` +
                              `Se creará una nueva línea solo_montaje con este componente. ` +
                              `Indica el precio de montaje (€) para esta nueva línea:`,
                              "0",
                            );
                            if (valor === null) return;
                            const precio = parseFloat(String(valor).replace(",", "."));
                            if (isNaN(precio) || precio <= 0) {
                              toast.error("Precio inválido (debe ser > 0)");
                              return;
                            }
                            try {
                              const res = await api.post(`/componentes/${c.id}/promote-to-linea`, { precio_montaje: precio });
                              toast.success(`Línea creada: ${res.data?.nueva_linea?.descripcion || "OK"}`);
                              load();
                            } catch (e) {
                              toast.error(e?.response?.data?.detail || "Error promoviendo");
                            }
                          }}>
                          <Split className="w-3 h-3" />
                        </Button>
                      )}
                      <Button size="sm" variant="ghost" className="h-6 w-6 p-0 text-zinc-500 hover:text-red-400"
                        onClick={async () => { if (confirm("¿Eliminar componente?" + (subsByParent[c.id] ? "\nTambién se borrarán las sub-piezas." : ""))) { await api.delete(`/componentes/${c.id}`); load(); } }}>
                        <Trash2 className="w-3 h-3" />
                      </Button>
                    </div>
                  </div>
                );
              };
              return (
                <>
                  {padres.map((p) => (
                    <React.Fragment key={p.id}>
                      {renderRow(p, false)}
                      {(subsByParent[p.id] || []).map((sub) => renderRow(sub, true))}
                    </React.Fragment>
                  ))}
                  {huerfanos.map((h) => renderRow(h, true))}
                </>
              );
            })()}
            {componentes.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm">Sin componentes todavía.</div>}
          </div>
        </TabsContent>

        {/* === ECONOMICO === */}
        <TabsContent value="economico" className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5">
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Presupuesto</div>
              <div className="text-2xl font-bold mt-2 text-amber-300">{totalPresup.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</div>
              <div className="text-xs text-zinc-500 mt-1">∑ componentes (precio × cant.)</div>
            </div>
            <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5">
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Coste estimado</div>
              <div className="text-2xl font-bold mt-2 text-orange-300">{totalCostes.toLocaleString("es-ES", { minimumFractionDigits: 2 })} €</div>
              <div className="text-xs text-zinc-500 mt-1">∑ componentes (coste × cant.)</div>
            </div>
            <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5">
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Margen</div>
              <div className="text-2xl font-bold mt-2 text-emerald-300">{margen}%</div>
              <div className="text-xs text-zinc-500 mt-1">Beneficio bruto previsto</div>
            </div>
            <div className={`border rounded-xl p-5 ${pendAaff > 0 ? "bg-red-500/5 border-red-500/30" : "bg-emerald-500/5 border-emerald-500/30"}`}>
              <div className="text-[10px] uppercase tracking-wider text-zinc-500 flex items-center gap-1">
                {pendAaff > 0 ? <AlertCircle className="w-3 h-3 text-red-400" /> : "✓"} AAFF
              </div>
              <div className={`text-2xl font-bold mt-2 ${pendAaff > 0 ? "text-red-300" : "text-emerald-300"}`}>
                {pendAaff > 0 ? `${pendAaff} pend.` : "Todos OK"}
              </div>
              <div className="text-xs text-zinc-500 mt-1">
                {pendAaff > 0 ? "Componentes sin artes finales" : "Todos los AAFF recibidos"}
              </div>
            </div>
          </div>
          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5 mb-4">
            <div className="text-sm font-semibold mb-3">Desglose materiales vs montaje</div>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">Materiales</div>
                <div className="text-zinc-300">Presupuesto: <span className="text-amber-300 font-semibold">{(p.presupuesto_materiales || 0).toFixed(2)} €</span></div>
                <div className="text-zinc-300">Coste: <span className="text-orange-300 font-semibold">{(p.coste_materiales || 0).toFixed(2)} €</span></div>
              </div>
              <div>
                <div className="text-xs text-zinc-500 uppercase tracking-wider mb-1">Montaje (mano de obra)</div>
                <div className="text-zinc-300">Presupuesto: <span className="text-amber-300 font-semibold">{(p.presupuesto_montaje || 0).toFixed(2)} €</span></div>
                <div className="text-zinc-300">Coste: <span className="text-orange-300 font-semibold">{(p.coste_montaje || 0).toFixed(2)} €</span></div>
              </div>
            </div>
          </div>

          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5">
            <div className="text-sm font-semibold mb-3">Desglose por componente (solo padres, sin sub-piezas)</div>
            <div className="space-y-2">
              {componentes.filter((c) => !c.parent_id).map((c) => {
                const precio = (c.precio_unitario || 0) * (c.cantidad || 0);
                const coste = (c.coste_unitario || 0) * (c.cantidad || 0);
                return (
                  <div key={c.id} className="flex items-center justify-between text-sm border-b border-zinc-800/40 py-2">
                    <div className="text-zinc-300 truncate flex-1 flex items-center gap-2">
                      {c.nombre} <span className="text-zinc-500">×{c.cantidad}</span>
                      {c.origen === "produccion_propia" && !c.aaff_recibido && <span className="text-[9px] uppercase px-1.5 py-0.5 rounded bg-red-500/15 text-red-300">⏳ AAFF</span>}
                    </div>
                    <div className="text-zinc-500 mr-4 text-xs">Coste {coste.toFixed(2)} €</div>
                    <div className="text-zinc-100 font-medium">{precio.toFixed(2)} €</div>
                  </div>
                );
              })}
              <div className="flex items-center justify-between pt-3 mt-2 border-t border-zinc-800 text-sm font-semibold">
                <div>TOTAL</div>
                <div className="text-zinc-500 mr-4 text-xs">{totalCostes.toFixed(2)} €</div>
                <div className="text-amber-300">{totalPresup.toFixed(2)} €</div>
              </div>
            </div>
          </div>
        </TabsContent>

        {/* === GASTOS === */}
        <TabsContent value="gastos" className="mt-4 space-y-4">
          <GastosBlock peticionId={id} />
          <ExtrasFacturacionBlock
            peticionId={id}
            componentes={p?.lineas?.flatMap((l) => l.componentes || []) || []}
            onChange={load}
          />
        </TabsContent>

        {/* === TIMELINE === */}
        <TabsContent value="timeline" className="mt-4">
          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5 mb-4">
            <div className="flex gap-2">
              <Input value={comentario} onChange={(e) => setComentario(e.target.value)}
                placeholder="Añade un comentario o nota..."
                data-testid="timeline-comment-input"
                onKeyDown={(e) => { if (e.key === "Enter") enviarComentario(); }}
                className="bg-zinc-950 border-zinc-800" />
              <Button onClick={enviarComentario} data-testid="timeline-send-btn"
                className="bg-amber-500 hover:bg-amber-400 text-zinc-900 font-semibold">
                <Send className="w-4 h-4" />
              </Button>
            </div>
          </div>
          <div className="space-y-3 relative">
            <div className="absolute left-4 top-2 bottom-2 w-px bg-zinc-800" aria-hidden />
            {timeline.map((t) => (
              <div key={t.id} className="relative pl-12">
                <div className="absolute left-2 top-2 w-5 h-5 rounded-full bg-zinc-900 border-2 border-amber-500 flex items-center justify-center">
                  <MessageSquare className="w-2.5 h-2.5 text-amber-400" />
                </div>
                <div className="bg-zinc-900/40 border border-zinc-800 rounded-lg p-3">
                  <div className="flex items-center justify-between">
                    <div className="text-xs text-amber-300">{t.autor_nombre || "Sistema"}</div>
                    <div className="text-[10px] text-zinc-500">{new Date(t.created_at).toLocaleString("es-ES")}</div>
                  </div>
                  <div className="text-sm text-zinc-200 mt-1">{t.descripcion}</div>
                </div>
              </div>
            ))}
            {timeline.length === 0 && <div className="text-center text-sm text-zinc-500 py-8">Sin eventos todavía.</div>}
          </div>
        </TabsContent>

        {/* === HISTÓRICO DE ESTADOS === */}
        <TabsContent value="historial" className="mt-4">
          <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-5" data-testid="estado-historial-panel">
            <div className="flex items-center gap-2 mb-4">
              <History className="w-4 h-4 text-amber-400" />
              <h3 className="text-sm font-semibold text-zinc-100">Trazabilidad del trabajo</h3>
              <span className="text-[10px] text-zinc-500 ml-1">· {estadoHistorial.length} evento(s)</span>
            </div>
            {estadoHistorial.length === 0 ? (
              <div className="text-center text-sm text-zinc-500 py-10">
                Aún no hay cambios de estado registrados.
                <div className="text-[11px] text-zinc-600 mt-1">El histórico empieza a registrarse desde febrero 2026.</div>
              </div>
            ) : (
              <div className="space-y-3 relative">
                <div className="absolute left-4 top-2 bottom-2 w-px bg-zinc-800" aria-hidden />
                {estadoHistorial.map((h) => {
                  const fromBadge = ESTADO_PETICION[h.from] || { label: h.from, color: "bg-zinc-700 text-zinc-300" };
                  const toBadge = ESTADO_PETICION[h.to] || { label: h.to, color: "bg-zinc-700 text-zinc-300" };
                  return (
                    <div key={h.id} className="relative pl-12" data-testid={`historial-row-${h.id}`}>
                      <div className={`absolute left-2 top-2 w-5 h-5 rounded-full bg-zinc-900 border-2 ${h.automatico ? "border-cyan-500" : "border-amber-500"} flex items-center justify-center`}>
                        {h.automatico ? <Bot className="w-2.5 h-2.5 text-cyan-400" /> : <UserIcon className="w-2.5 h-2.5 text-amber-400" />}
                      </div>
                      <div className="bg-zinc-900/40 border border-zinc-800 rounded-lg p-3">
                        <div className="flex items-center justify-between flex-wrap gap-2">
                          <div className="flex items-center gap-2 text-xs flex-wrap">
                            <span className={`px-2 py-0.5 rounded ${fromBadge.color}`}>{fromBadge.label}</span>
                            <ChevronRight className="w-3 h-3 text-zinc-500" />
                            <span className={`px-2 py-0.5 rounded ${toBadge.color} font-semibold`}>{toBadge.label}</span>
                            {h.automatico && <span className="text-[10px] text-cyan-400 ml-1">(automático)</span>}
                          </div>
                          <div className="text-[10px] text-zinc-500">{new Date(h.created_at).toLocaleString("es-ES")}</div>
                        </div>
                        <div className="mt-1.5 text-xs text-zinc-400">
                          {h.automatico ? "Sistema" : (h.usuario_nombre || "Usuario")}
                          {h.motivo && <span className="ml-2 text-amber-300/80">· {h.motivo}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </TabsContent>
      </Tabs>

      {reporteModal && <ReporteMontajeModal data={reporteModal} onClose={() => setReporteModal(null)} />}
      {showMemoria && <MemoriaTecnicaDialog peticionId={id} onClose={() => setShowMemoria(false)} />}
      {showMemoriaMontaje && <MemoriaMontajeDialog peticionId={id} onClose={() => setShowMemoriaMontaje(false)} />}

      <RutaEditPinDialog
        open={!!montadoTarget}
        onOpenChange={(v) => { if (!v) setMontadoTarget(null); }}
        onUnlocked={async (pin) => {
          if (!montadoTarget) return;
          const url = montadoTarget.tipo === "peticion"
            ? `/peticiones/${montadoTarget.id}/marcar-montado`
            : `/lineas/${montadoTarget.id}/marcar-montado`;
          try {
            await api.post(url, {}, { headers: { "X-Ruta-Edit-Pin": pin } });
            toast.success(montadoTarget.tipo === "peticion"
              ? "✅ Petición marcada como MONTADA"
              : "✅ Línea marcada como MONTADA");
            setMontadoTarget(null);
            load();
          } catch (e) {
            toast.error(e?.response?.data?.detail || "Error marcando montado");
          }
        }}
      />

      <EditPeticionDialog
        open={editPeticionOpen}
        setOpen={setEditPeticionOpen}
        peticion={p}
        clientes={clientes}
        users={users}
        onSaved={load}
      />

      {/* Modal de detalle del componente — reutilizado desde Mi Producción */}
      <ComponenteDetailModal
        open={!!detailComponenteId}
        componenteId={detailComponenteId}
        onClose={() => setDetailComponenteId(null)}
        onEstadoChange={() => load()}
      />

      {/* ─── Diálogo Duplicar componente (Iter 73 - bug Fernando: ahora pregunta línea destino) ─── */}
      <Dialog open={!!dupComp} onOpenChange={(v) => { if (!v) setDupComp(null); }}>
        <DialogContent className="bg-zinc-950 border-blue-500/40 max-w-md" data-testid="dialog-duplicar-componente">
          <DialogHeader>
            <DialogTitle className="text-blue-200">Duplicar componente</DialogTitle>
          </DialogHeader>
          {dupComp && (
            <div className="space-y-3 text-sm">
              <div className="rounded-md border border-blue-500/30 bg-blue-500/5 p-3 text-xs text-blue-100">
                Se creará una copia de <b className="text-blue-200">{dupComp.nombre}</b>. Elige a qué línea va la copia.
              </div>
              <div>
                <Label className="text-xs text-zinc-400">Línea destino *</Label>
                <Select value={dupLineaId} onValueChange={setDupLineaId}>
                  <SelectTrigger data-testid="dup-linea-select" className="bg-zinc-900 border-zinc-800 mt-1">
                    <SelectValue placeholder="Selecciona línea destino" />
                  </SelectTrigger>
                  <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
                    {lineas.map((l) => {
                      const esp = espacios.find((e) => e.id === l.espacio_id);
                      const isSrc = l.id === dupComp.linea_id;
                      return (
                        <SelectItem key={l.id} value={l.id}>
                          {(TIPO_LINEA[l.tipo]?.label || l.tipo)} — {esp?.nombre || "—"}
                          {isSrc && " · (origen)"}
                        </SelectItem>
                      );
                    })}
                  </SelectContent>
                </Select>
                {dupLineaId && dupLineaId !== dupComp.linea_id && (
                  <div className="text-[11px] text-amber-300 mt-1">
                    ⚠ La copia se moverá a una línea distinta del original.
                  </div>
                )}
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="ghost" onClick={() => setDupComp(null)} disabled={duplicando} data-testid="dup-cancel">
              Cancelar
            </Button>
            <Button
              data-testid="dup-confirmar"
              disabled={duplicando || !dupLineaId}
              onClick={async () => {
                if (!dupComp || !dupLineaId) return;
                setDuplicando(true);
                try {
                  await api.post(`/componentes/${dupComp.id}/duplicar`, { linea_id: dupLineaId });
                  toast.success("Componente duplicado");
                  setDupComp(null);
                  load();
                } catch (e) {
                  toast.error(e?.response?.data?.detail || "Error duplicando");
                } finally {
                  setDuplicando(false);
                }
              }}
              className="bg-blue-500 hover:bg-blue-400 text-zinc-950 font-bold">
              {duplicando ? "Duplicando…" : "Duplicar"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* ─── Diálogo Finalizar petición a mano (Iter 73) ─── */}
      <Dialog open={openFinalizar} onOpenChange={setOpenFinalizar}>
        <DialogContent className="bg-zinc-950 border-rose-500/40 max-w-xl" data-testid="dialog-finalizar-peticion">
          <DialogHeader>
            <DialogTitle className="text-rose-200">Finalizar petición a mano</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 text-sm">
            <div className="rounded-md border border-rose-500/30 bg-rose-500/5 p-3 text-xs text-rose-100">
              Esta acción <b>cierra</b> la petición y marca como <b>canceladas</b> las líneas y componentes pendientes. Los ya producidos quedan como cargo del cliente.
            </div>

            <div>
              <Label className="text-xs text-zinc-400">Motivo *</Label>
              <select
                value={finMotivoCorto}
                onChange={(e) => setFinMotivoCorto(e.target.value)}
                data-testid="fin-motivo-corto"
                className="w-full bg-zinc-900 border border-zinc-800 rounded px-2 py-2 text-sm mt-1">
                <option value="cliente_canc">Cliente canceló</option>
                <option value="duplicada">Petición duplicada</option>
                <option value="no_procede">No procede</option>
                <option value="otro">Otro</option>
              </select>
              <Textarea
                value={finMotivo}
                onChange={(e) => setFinMotivo(e.target.value)}
                data-testid="fin-motivo-texto"
                placeholder="Detalle del motivo (obligatorio)…"
                rows={3}
                maxLength={1000}
                className="bg-zinc-900 border-zinc-800 mt-2"
              />
            </div>

            {cargosEstim && (
              <div className="rounded-md border border-amber-500/30 bg-amber-500/5 p-3 text-xs space-y-1.5">
                <div className="text-amber-200 font-bold text-[11px] uppercase tracking-wider">Cargos posibles ya generados</div>
                <div className="grid grid-cols-3 gap-2 mt-1">
                  <div className="text-center">
                    <div className="text-[9px] text-zinc-500 uppercase">Líneas</div>
                    <div className="text-amber-100 font-mono font-bold">{cargosEstim.lineas?.total?.toFixed(2)} €</div>
                    <div className="text-[9px] text-zinc-500">{cargosEstim.lineas?.count || 0} líneas</div>
                  </div>
                  <div className="text-center">
                    <div className="text-[9px] text-zinc-500 uppercase">Producidos</div>
                    <div className="text-amber-100 font-mono font-bold">{cargosEstim.componentes_producidos?.total?.toFixed(2)} €</div>
                    <div className="text-[9px] text-zinc-500">{cargosEstim.componentes_producidos?.count || 0} comps</div>
                  </div>
                  <div className="text-center">
                    <div className="text-[9px] text-zinc-500 uppercase">Gastos</div>
                    <div className="text-amber-100 font-mono font-bold">{cargosEstim.gastos?.total?.toFixed(2)} €</div>
                    <div className="text-[9px] text-zinc-500">{cargosEstim.gastos?.count || 0} ítems</div>
                  </div>
                </div>
                <div className="pt-2 border-t border-amber-500/20 flex items-center justify-between">
                  <span className="text-zinc-300">Total sugerido a facturar:</span>
                  <span className="text-amber-200 font-bold font-mono text-base">{cargosEstim.total_sugerido?.toFixed(2)} €</span>
                </div>
              </div>
            )}

            <div>
              <Label className="text-xs text-zinc-400">Cargos a facturar al cliente (€)</Label>
              <Input
                type="number"
                step="0.01"
                min="0"
                value={finCargos}
                onChange={(e) => setFinCargos(e.target.value)}
                data-testid="fin-cargos"
                placeholder="0.00"
                className="bg-zinc-900 border-zinc-800 mt-1 font-mono"
              />
            </div>

            <div>
              <Label className="text-xs text-zinc-400">Notas internas (opcional)</Label>
              <Input
                value={finNotas}
                onChange={(e) => setFinNotas(e.target.value)}
                data-testid="fin-notas"
                maxLength={1000}
                className="bg-zinc-900 border-zinc-800 mt-1"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpenFinalizar(false)} disabled={finalizando} data-testid="fin-cancel">
              Cancelar
            </Button>
            <Button onClick={ejecutarFinalizar} disabled={finalizando || !finMotivo.trim()}
              data-testid="fin-confirmar"
              className="bg-rose-500 hover:bg-rose-400 text-zinc-950 font-bold">
              {finalizando ? "Procesando…" : "Finalizar petición"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

